import React from "react";
import { Link } from "react-router-dom";

const ProjectsItem = (props) => {
    return (
        <div className="projectItem"> 
            <div className="proj-detail">
                <h2>{props.name}</h2>
                <p>{props.detail}</p>
                <Link to={props.url} target={"_blank"} className="link-proj"><button>See Live</button></Link>
            </div>
            <img src={props.image} alt="ProjectItem"/>
        </div>
    )
}
export default ProjectsItem;